import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

import { BasicValidators } from '../shared/basic-validators';
import { StakeholdersModel } from "./stakeholders.model";
import { StakeholdersService } from './stakeholders.service';
import { Funcoes } from "../funcoes";
import { Global } from "../global";


@Component({
  selector: 'app-stakeholders-form',
  templateUrl: './stakeholders-form.component.html'
})
export class StakeholdersFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  stakeholder: StakeholdersModel = new StakeholdersModel();
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  enviando = false;

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private stakeholdersService: StakeholdersService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {
    this.form = formBuilder.group({
      id: [],
      nome: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]],
      empresa: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]],
      funcao_pt: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]],
      funcao_en: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]],
      funcao_es: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]]
    });
  }

  ngOnInit() {

    // verifica se é uma página de edição
    if (this.router.url.split(/\//).pop() == 'upd') {
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if (this.router.url.split(/\//).pop() == 'add') {
      this.pageIsAdd = true;
    }

    var id = this.route.params.subscribe(params => {
      var id = params['id_stakeholder'];

      if (!this.pageIsUpd) {
        this.title = this.func.traduzir('front.visualizarStakeholder');
      } else {
        this.title = id ? this.func.traduzir('front.editarStakeholder') : this.func.traduzir('front.addStakeholder');
      }

      if (!id) {
        return;
      }

      this.stakeholdersService.getById(id)
        .subscribe(
          json => {
            if (this.pageIsUpd) {
              this.title = this.func.traduzir('front.editarStakeholder') + ': ' + json.Payload[0].nome;
            } else {
              this.title = this.func.traduzir('front.visualizarStakeholder') + ': ' + json.Payload[0].nome;
            }

            this.stakeholder = json.Payload[0];

            if (this.global.debug == true) {
              console.log(json.Payload[0]);
            }
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

  save() {
    this.enviando = true;
    var result,
      values = this.form.value;

    if (values.id) {
      result = this.stakeholdersService.editar(values, values.id);
    } else {
      result = this.stakeholdersService.adicionar(values);
    }

    result.subscribe(data => this.router.navigate(['/painel', 'laudos-cd', 'stakeholders']),
      error => {
        this.enviando = false;
        let json = error.json();
        this.func.showErro(json);

        if (json.Message && json.Message.ErrorInput) {
          for (let i in json.Message.ErrorInput) {
            let erro = {};
            erro[i] = json.Message.ErrorInput[i];
            this.form.controls[i].setErrors(erro);
          }
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/laudos-cd-stakeholders/stakeholders-form.component.ts